module.exports = __webpack_public_path__ + "static/media/sudoGPRseven.8bd7f097.jpg";